import type { ResumeData } from "./index";
import { sampleResume } from "./sample";

// English sample resume
const sampleResumeEnglish = sampleResume;

// Spanish sample resume
const sampleResumeSpanish: ResumeData = {
  ...sampleResume,
  basics: {
    ...sampleResume.basics,
    name: "Juan López",
    headline: "Desarrollador Web Creativo e Innovador",
    email: "juan.lopez@stylion.io",
    phone: "(555) 123-4567",
    location: "Madrid, España",
  },
  sections: {
    ...sampleResume.sections,
    summary: {
      ...sampleResume.sections.summary,
      name: "Resumen",
      content:
        "<p>Desarrollador Web innovador con 5 años de experiencia en la creación de sitios web y aplicaciones impactantes y fáciles de usar. Se especializa en <strong>tecnologías front-end</strong> y apasionado por los estándares web modernos y las técnicas de desarrollo de vanguardia. Historial probado de proyectos exitosos desde el concepto hasta la implementación.</p>",
    },
    awards: {
      ...sampleResume.sections.awards,
      name: "Premios",
    },
    certifications: {
      ...sampleResume.sections.certifications,
      name: "Certificaciones",
      items: [
        {
          ...sampleResume.sections.certifications.items[0],
          name: "Desarrollo Web Full-Stack",
          issuer: "CodeAcademy",
        },
        {
          ...sampleResume.sections.certifications.items[1],
          name: "Desarrollador Certificado AWS",
          issuer: "Amazon Web Services",
        },
      ],
    },
    education: {
      ...sampleResume.sections.education,
      name: "Educación",
      items: [
        {
          ...sampleResume.sections.education.items[0],
          institution: "Universidad Complutense de Madrid",
          studyType: "Grado en Ingeniería Informática",
          area: "Madrid, España",
          date: "Agosto 2012 a Mayo 2016",
        },
      ],
    },
    experience: {
      ...sampleResume.sections.experience,
      name: "Experiencia",
      items: [
        {
          ...sampleResume.sections.experience.items[0],
          company: "Soluciones Creativas SL",
          position: "Desarrollador Web Senior",
          location: "Madrid, España",
          date: "Enero 2019 a Presente",
          summary:
            "<ul><li><p>Lideré el rediseño del sitio web principal del producto, resultando en un aumento del 40% en la participación de los usuarios.</p></li><li><p>Desarrollé e implementé un nuevo marco responsive, mejorando la compatibilidad entre dispositivos.</p></li><li><p>Mentoreé a un equipo de cuatro desarrolladores junior, fomentando una cultura de excelencia técnica.</p></li></ul>",
        },
        {
          ...sampleResume.sections.experience.items[1],
          company: "TechAdvancers España",
          position: "Desarrollador Web",
          location: "Barcelona, España",
          date: "Junio 2016 a Diciembre 2018",
          summary:
            "<ul><li><p>Colaboré en un equipo de 10 personas para desarrollar aplicaciones web de alta calidad utilizando React.js y Node.js.</p></li><li><p>Gestioné la integración de servicios de terceros como Stripe para pagos y Twilio para servicios SMS.</p></li><li><p>Optimicé el rendimiento de la aplicación, logrando una reducción del 30% en los tiempos de carga.</p></li></ul>",
        },
      ],
    },
    volunteer: {
      ...sampleResume.sections.volunteer,
      name: "Voluntariado",
    },
    profiles: {
      ...sampleResume.sections.profiles,
      name: "Perfiles",
    },
    projects: {
      ...sampleResume.sections.projects,
      name: "Proyectos",
      items: [
        {
          ...sampleResume.sections.projects.items[0],
          name: "Plataforma E-Commerce",
          description: "Líder del Proyecto",
          summary:
            "<p>Dirigí el desarrollo de una plataforma de comercio electrónico full-stack, mejorando la conversión de ventas en un 25%.</p>",
        },
        {
          ...sampleResume.sections.projects.items[1],
          name: "Panel de Control Interactivo",
          description: "Desarrollador Frontend",
          summary:
            "<p>Creé un panel de control analítico interactivo para una aplicación SaaS, mejorando la visualización de datos para los clientes.</p>",
        },
      ],
    },
    publications: {
      ...sampleResume.sections.publications,
      name: "Publicaciones",
    },
    references: {
      ...sampleResume.sections.references,
      name: "Referencias",
      items: [
        {
          ...sampleResume.sections.references.items[0],
          name: "Disponible bajo petición",
        },
      ],
    },
    skills: {
      ...sampleResume.sections.skills,
      name: "Habilidades",
      items: [
        {
          ...sampleResume.sections.skills.items[0],
          name: "Tecnologías Web",
          description: "Avanzado",
        },
        {
          ...sampleResume.sections.skills.items[1],
          name: "Frameworks Web",
          description: "Intermedio",
        },
        {
          ...sampleResume.sections.skills.items[2],
          name: "Herramientas",
          description: "Intermedio",
        },
      ],
    },
    hobbies: {
      ...sampleResume.sections.hobbies,
      name: "Pasatiempos",
      items: [
        { ...sampleResume.sections.hobbies.items[0], name: "Baloncesto" },
        { ...sampleResume.sections.hobbies.items[1], name: "Lectura" },
      ],
    },
    mostProudOf: {
      ...sampleResume.sections.mostProudOf,
      name: "Fortalezas Principales",
      items: [
        { ...sampleResume.sections.mostProudOf.items[0], name: "Proyectos de Alto Impacto", description: "Lideré y entregué proyectos clave a tiempo, superando las expectativas y generando resultados medibles." },
        { ...sampleResume.sections.mostProudOf.items[1], name: "Equipos Sólidos", description: "Fomenté entornos colaborativos que impulsaron la productividad, la moral y el crecimiento profesional." },
        { ...sampleResume.sections.mostProudOf.items[2], name: "Crecimiento Profesional", description: "Comprometido con el aprendizaje continuo mediante certificaciones, talleres y seguimiento de tendencias." },
      ],
    },
    myMind: {
      ...sampleResume.sections.myMind,
      name: "Mentalidad y Fortalezas",
      items: [
        { ...sampleResume.sections.myMind.items[0], label: "Liderazgo", description: "Guiando equipos hacia metas compartidas con confianza" },
        { ...sampleResume.sections.myMind.items[1], label: "Resolución de Problemas", description: "Analizando desafíos y entregando resultados efectivos" },
        { ...sampleResume.sections.myMind.items[2], label: "Colaboración", description: "Trabajando eficazmente con equipos diversos para lograr el éxito" },
        { ...sampleResume.sections.myMind.items[3], label: "Creatividad", description: "Generando ideas innovadoras y soluciones únicas" },
      ],
      ringThickness: 4,
      showLegend: true,
      legendPlacement: "right" as const,
    },
    interests: {
      ...sampleResume.sections.interests,
      name: "Intereses",
      items: [
        { ...sampleResume.sections.interests.items[0], name: "Innovación Tecnológica", keywords: ["Inteligencia Artificial", "Aprendizaje Automático", "Blockchain"] },
        { ...sampleResume.sections.interests.items[1], name: "Desarrollo Profesional", keywords: ["Liderazgo", "Mentoría", "Networking"] },
      ],
    },
    languages: {
      ...sampleResume.sections.languages,
      name: "Idiomas",
      items: [
        { ...sampleResume.sections.languages.items[0], name: "Español", description: "Nativo" },
        { ...sampleResume.sections.languages.items[1], name: "Inglés", description: "Avanzado" },
      ],
    },
    custom: {},
  },
};

// German sample resume
const sampleResumeGerman: ResumeData = {
  ...sampleResume,
  basics: {
    ...sampleResume.basics,
    name: "Hans Müller",
    headline: "Kreativer und Innovativer Webentwickler",
    email: "hans.mueller@stylion.io",
    phone: "(555) 123-4567",
    location: "Berlin, Deutschland",
  },
  sections: {
    ...sampleResume.sections,
    summary: {
      ...sampleResume.sections.summary,
      name: "Zusammenfassung",
      content:
        "<p>Innovativer Webentwickler mit 5 Jahren Erfahrung in der Erstellung wirkungsvoller und benutzerfreundlicher Websites und Anwendungen. Spezialisiert auf <strong>Front-End-Technologien</strong> und begeistert von modernen Webstandards und hochmodernen Entwicklungstechniken. Nachgewiesene Erfolgsbilanz bei der Leitung erfolgreicher Projekte vom Konzept bis zur Bereitstellung.</p>",
    },
    awards: {
      ...sampleResume.sections.awards,
      name: "Auszeichnungen",
    },
    certifications: {
      ...sampleResume.sections.certifications,
      name: "Zertifizierungen",
      items: [
        {
          ...sampleResume.sections.certifications.items[0],
          name: "Full-Stack Webentwicklung",
          issuer: "CodeAcademy",
        },
        {
          ...sampleResume.sections.certifications.items[1],
          name: "AWS Zertifizierter Entwickler",
          issuer: "Amazon Web Services",
        },
      ],
    },
    education: {
      ...sampleResume.sections.education,
      name: "Bildung",
      items: [
        {
          ...sampleResume.sections.education.items[0],
          institution: "Technische Universität Berlin",
          studyType: "Bachelor in Informatik",
          area: "Berlin, Deutschland",
          date: "August 2012 bis Mai 2016",
        },
      ],
    },
    experience: {
      ...sampleResume.sections.experience,
      name: "Erfahrung",
      items: [
        {
          ...sampleResume.sections.experience.items[0],
          company: "Kreative Lösungen GmbH",
          position: "Senior Webentwickler",
          location: "Berlin, Deutschland",
          date: "Januar 2019 bis Heute",
          summary:
            "<ul><li><p>Führte die Neugestaltung der Hauptproduktwebsite an, was zu einer 40%igen Steigerung des Nutzerengagements führte.</p></li><li><p>Entwickelte und implementierte ein neues responsives Framework, das die geräteübergreifende Kompatibilität verbesserte.</p></li><li><p>Betreute ein Team von vier Junior-Entwicklern und förderte eine Kultur der technischen Exzellenz.</p></li></ul>",
        },
        {
          ...sampleResume.sections.experience.items[1],
          company: "TechAdvancers Deutschland",
          position: "Webentwickler",
          location: "München, Deutschland",
          date: "Juni 2016 bis Dezember 2018",
          summary:
            "<ul><li><p>Arbeitete in einem 10-köpfigen Team an der Entwicklung hochwertiger Webanwendungen mit React.js und Node.js.</p></li><li><p>Verwaltete die Integration von Drittanbieterdiensten wie Stripe für Zahlungen und Twilio für SMS-Dienste.</p></li><li><p>Optimierte die Anwendungsleistung und erreichte eine 30%ige Reduzierung der Ladezeiten.</p></li></ul>",
        },
      ],
    },
    volunteer: {
      ...sampleResume.sections.volunteer,
      name: "Ehrenamt",
    },
    profiles: {
      ...sampleResume.sections.profiles,
      name: "Profile",
    },
    projects: {
      ...sampleResume.sections.projects,
      name: "Projekte",
      items: [
        {
          ...sampleResume.sections.projects.items[0],
          name: "E-Commerce Plattform",
          description: "Projektleiter",
          summary:
            "<p>Leitete die Entwicklung einer Full-Stack-E-Commerce-Plattform, die die Verkaufskonversion um 25% verbesserte.</p>",
        },
        {
          ...sampleResume.sections.projects.items[1],
          name: "Interaktives Dashboard",
          description: "Frontend-Entwickler",
          summary:
            "<p>Erstellte ein interaktives Analyse-Dashboard für eine SaaS-Anwendung und verbesserte die Datenvisualisierung für Kunden.</p>",
        },
      ],
    },
    publications: {
      ...sampleResume.sections.publications,
      name: "Publikationen",
    },
    references: {
      ...sampleResume.sections.references,
      name: "Referenzen",
      items: [
        {
          ...sampleResume.sections.references.items[0],
          name: "Auf Anfrage verfügbar",
        },
      ],
    },
    skills: {
      ...sampleResume.sections.skills,
      name: "Fähigkeiten",
      items: [
        {
          ...sampleResume.sections.skills.items[0],
          name: "Web-Technologien",
          description: "Fortgeschritten",
        },
        {
          ...sampleResume.sections.skills.items[1],
          name: "Web-Frameworks",
          description: "Mittel",
        },
        {
          ...sampleResume.sections.skills.items[2],
          name: "Tools",
          description: "Mittel",
        },
      ],
    },
    hobbies: {
      ...sampleResume.sections.hobbies,
      name: "Hobbys",
      items: [
        { ...sampleResume.sections.hobbies.items[0], name: "Basketball" },
        { ...sampleResume.sections.hobbies.items[1], name: "Lesen" },
      ],
    },
    mostProudOf: {
      ...sampleResume.sections.mostProudOf,
      name: "Kernstärken",
      items: [
        { ...sampleResume.sections.mostProudOf.items[0], name: "Wirkungsvolle Projekte", description: "Schlüsselprojekte termingerecht geleitet und geliefert, Erwartungen übertroffen und messbare Ergebnisse erzielt." },
        { ...sampleResume.sections.mostProudOf.items[1], name: "Starke Teams Aufgebaut", description: "Kollaborative Teamumgebungen gefördert, die Produktivität, Moral und berufliches Wachstum gesteigert haben." },
        { ...sampleResume.sections.mostProudOf.items[2], name: "Berufliche Weiterentwicklung", description: "Dem lebenslangen Lernen durch Zertifizierungen, Workshops und aktuelle Branchentrends verpflichtet." },
      ],
    },
    myMind: {
      ...sampleResume.sections.myMind,
      name: "Denkweise & Stärken",
      items: [
        { ...sampleResume.sections.myMind.items[0], label: "Führung", description: "Teams mit Zuversicht zu gemeinsamen Zielen führen" },
        { ...sampleResume.sections.myMind.items[1], label: "Problemlösung", description: "Herausforderungen analysieren und effektive Ergebnisse liefern" },
        { ...sampleResume.sections.myMind.items[2], label: "Zusammenarbeit", description: "Effektiv mit vielfältigen Teams zusammenarbeiten" },
        { ...sampleResume.sections.myMind.items[3], label: "Kreativität", description: "Innovative Ideen und einzigartige Lösungen entwickeln" },
      ],
      ringThickness: 4,
      showLegend: true,
      legendPlacement: "right" as const,
    },
    interests: {
      ...sampleResume.sections.interests,
      name: "Interessen",
      items: [
        { ...sampleResume.sections.interests.items[0], name: "Technologische Innovation", keywords: ["Künstliche Intelligenz", "Maschinelles Lernen", "Blockchain"] },
        { ...sampleResume.sections.interests.items[1], name: "Berufliche Entwicklung", keywords: ["Führung", "Mentoring", "Branchennetzwerk"] },
      ],
    },
    languages: {
      ...sampleResume.sections.languages,
      name: "Sprachen",
      items: [
        { ...sampleResume.sections.languages.items[0], name: "Deutsch", description: "Muttersprache" },
        { ...sampleResume.sections.languages.items[1], name: "Englisch", description: "Fließend" },
      ],
    },
    custom: {},
  },
};

// French sample resume
const sampleResumeFrench: ResumeData = {
  ...sampleResume,
  basics: {
    ...sampleResume.basics,
    name: "Jean Dupont",
    headline: "Développeur Web Créatif et Innovant",
    email: "jean.dupont@stylion.io",
    phone: "(555) 123-4567",
    location: "Paris, France",
  },
  sections: {
    ...sampleResume.sections,
    summary: {
      ...sampleResume.sections.summary,
      name: "Résumé",
      content:
        "<p>Développeur Web innovant avec 5 ans d'expérience dans la création de sites web et d'applications impactants et conviviaux. Spécialisé dans les <strong>technologies front-end</strong> et passionné par les standards web modernes et les techniques de développement de pointe. Parcours prouvé de projets réussis du concept au déploiement.</p>",
    },
    awards: {
      ...sampleResume.sections.awards,
      name: "Récompenses",
    },
    certifications: {
      ...sampleResume.sections.certifications,
      name: "Certifications",
      items: [
        {
          ...sampleResume.sections.certifications.items[0],
          name: "Développement Web Full-Stack",
          issuer: "CodeAcademy",
        },
        {
          ...sampleResume.sections.certifications.items[1],
          name: "Développeur Certifié AWS",
          issuer: "Amazon Web Services",
        },
      ],
    },
    education: {
      ...sampleResume.sections.education,
      name: "Formation",
      items: [
        {
          ...sampleResume.sections.education.items[0],
          institution: "Université Paris-Saclay",
          studyType: "Licence en Informatique",
          area: "Paris, France",
          date: "Août 2012 à Mai 2016",
        },
      ],
    },
    experience: {
      ...sampleResume.sections.experience,
      name: "Expérience",
      items: [
        {
          ...sampleResume.sections.experience.items[0],
          company: "Solutions Créatives SA",
          position: "Développeur Web Senior",
          location: "Paris, France",
          date: "Janvier 2019 à Présent",
          summary:
            "<ul><li><p>Dirigé la refonte du site web principal du produit, entraînant une augmentation de 40% de l'engagement des utilisateurs.</p></li><li><p>Développé et mis en œuvre un nouveau framework responsive, améliorant la compatibilité entre les appareils.</p></li><li><p>Mentoré une équipe de quatre développeurs juniors, favorisant une culture d'excellence technique.</p></li></ul>",
        },
        {
          ...sampleResume.sections.experience.items[1],
          company: "TechAdvancers France",
          position: "Développeur Web",
          location: "Lyon, France",
          date: "Juin 2016 à Décembre 2018",
          summary:
            "<ul><li><p>Collaboré au sein d'une équipe de 10 personnes pour développer des applications web de haute qualité utilisant React.js et Node.js.</p></li><li><p>Géré l'intégration de services tiers tels que Stripe pour les paiements et Twilio pour les services SMS.</p></li><li><p>Optimisé les performances de l'application, réalisant une réduction de 30% des temps de chargement.</p></li></ul>",
        },
      ],
    },
    volunteer: {
      ...sampleResume.sections.volunteer,
      name: "Bénévolat",
    },
    profiles: {
      ...sampleResume.sections.profiles,
      name: "Profils",
    },
    projects: {
      ...sampleResume.sections.projects,
      name: "Projets",
      items: [
        {
          ...sampleResume.sections.projects.items[0],
          name: "Plateforme E-Commerce",
          description: "Chef de Projet",
          summary:
            "<p>Dirigé le développement d'une plateforme e-commerce full-stack, améliorant la conversion des ventes de 25%.</p>",
        },
        {
          ...sampleResume.sections.projects.items[1],
          name: "Tableau de Bord Interactif",
          description: "Développeur Frontend",
          summary:
            "<p>Créé un tableau de bord analytique interactif pour une application SaaS, améliorant la visualisation des données pour les clients.</p>",
        },
      ],
    },
    publications: {
      ...sampleResume.sections.publications,
      name: "Publications",
    },
    references: {
      ...sampleResume.sections.references,
      name: "Références",
      items: [
        {
          ...sampleResume.sections.references.items[0],
          name: "Disponibles sur demande",
        },
      ],
    },
    skills: {
      ...sampleResume.sections.skills,
      name: "Compétences",
      items: [
        {
          ...sampleResume.sections.skills.items[0],
          name: "Technologies Web",
          description: "Avancé",
        },
        {
          ...sampleResume.sections.skills.items[1],
          name: "Frameworks Web",
          description: "Intermédiaire",
        },
        {
          ...sampleResume.sections.skills.items[2],
          name: "Outils",
          description: "Intermédiaire",
        },
      ],
    },
    hobbies: {
      ...sampleResume.sections.hobbies,
      name: "Loisirs",
      items: [
        { ...sampleResume.sections.hobbies.items[0], name: "Basketball" },
        { ...sampleResume.sections.hobbies.items[1], name: "Lecture" },
      ],
    },
    mostProudOf: {
      ...sampleResume.sections.mostProudOf,
      name: "Points Forts",
      items: [
        { ...sampleResume.sections.mostProudOf.items[0], name: "Projets à Fort Impact", description: "Dirigé et livré des projets clés dans les délais, dépassant les attentes et produisant des résultats mesurables." },
        { ...sampleResume.sections.mostProudOf.items[1], name: "Équipes Solides", description: "Favorisé des environnements collaboratifs qui ont stimulé la productivité, le moral et la croissance professionnelle." },
        { ...sampleResume.sections.mostProudOf.items[2], name: "Développement Professionnel", description: "Engagé dans l'apprentissage continu par des certifications, ateliers et suivi des tendances du secteur." },
      ],
    },
    myMind: {
      ...sampleResume.sections.myMind,
      name: "État d'Esprit & Forces",
      items: [
        { ...sampleResume.sections.myMind.items[0], label: "Leadership", description: "Guider les équipes vers des objectifs communs avec confiance" },
        { ...sampleResume.sections.myMind.items[1], label: "Résolution de Problèmes", description: "Analyser les défis et fournir des résultats efficaces" },
        { ...sampleResume.sections.myMind.items[2], label: "Collaboration", description: "Travailler efficacement avec des équipes diverses" },
        { ...sampleResume.sections.myMind.items[3], label: "Créativité", description: "Générer des idées innovantes et des solutions uniques" },
      ],
      ringThickness: 4,
      showLegend: true,
      legendPlacement: "right" as const,
    },
    interests: {
      ...sampleResume.sections.interests,
      name: "Centres d'intérêt",
      items: [
        { ...sampleResume.sections.interests.items[0], name: "Innovation Technologique", keywords: ["Intelligence Artificielle", "Apprentissage Automatique", "Blockchain"] },
        { ...sampleResume.sections.interests.items[1], name: "Développement Professionnel", keywords: ["Leadership", "Mentorat", "Réseautage"] },
      ],
    },
    languages: {
      ...sampleResume.sections.languages,
      name: "Langues",
      items: [
        { ...sampleResume.sections.languages.items[0], name: "Français", description: "Langue maternelle" },
        { ...sampleResume.sections.languages.items[1], name: "Anglais", description: "Courant" },
      ],
    },
    custom: {},
  },
};

// Arabic sample resume
const sampleResumeArabic: ResumeData = {
  ...sampleResume,
  basics: {
    ...sampleResume.basics,
    name: "اسمك هنا",
    headline: "المسمى الوظيفي",
    email: "email.address@xyzx.com",
    phone: "(555) 123-4567",
    location: "المدينة، الدولة",
  },
  sections: {
    ...sampleResume.sections,
    summary: {
      ...sampleResume.sections.summary,
      name: "ملخص",
      content:
        "<p>اكتب نبذة مختصرة عن نفسك وخبراتك وأهدافك المهنية. أبرز <strong>مهاراتك الأساسية</strong> وما يميزك كمحترف.</p>",
    },
    awards: {
      ...sampleResume.sections.awards,
      name: "الجوائز",
    },
    certifications: {
      ...sampleResume.sections.certifications,
      name: "الشهادات",
      items: [
        {
          ...sampleResume.sections.certifications.items[0],
          name: "اسم الشهادة",
          issuer: "الجهة المانحة",
          date: "01/01/2026",
        },
        {
          ...sampleResume.sections.certifications.items[1],
          name: "اسم الشهادة",
          issuer: "الجهة المانحة",
          date: "01/01/2026",
        },
      ],
    },
    education: {
      ...sampleResume.sections.education,
      name: "التعليم",
      items: [
        {
          ...sampleResume.sections.education.items[0],
          institution: "اسم الجامعة",
          studyType: "الدرجة العلمية",
          area: "المدينة، الدولة",
          date: "01/01/2020 إلى 01/01/2024",
        },
      ],
    },
    experience: {
      ...sampleResume.sections.experience,
      name: "الخبرة",
      items: [
        {
          ...sampleResume.sections.experience.items[0],
          company: "اسم الشركة",
          position: "المسمى الوظيفي",
          location: "المدينة، الدولة",
          date: "01/01/2022 إلى الآن",
          summary:
            "<ul><li><p>اذكر مسؤوليتك الرئيسية أو إنجازك في هذا الدور.</p></li><li><p>اذكر مشروعاً محدداً أو نتيجة ساهمت فيها.</p></li><li><p>أبرز أي مهارات قيادية أو تقنية أو عمل جماعي طبقتها.</p></li></ul>",
        },
        {
          ...sampleResume.sections.experience.items[1],
          company: "اسم الشركة",
          position: "المسمى الوظيفي",
          location: "المدينة، الدولة",
          date: "01/01/2020 إلى 01/01/2022",
          summary:
            "<ul><li><p>اذكر مسؤوليتك الرئيسية أو إنجازك في هذا الدور.</p></li><li><p>اذكر مشروعاً محدداً أو نتيجة ساهمت فيها.</p></li><li><p>أبرز أي مهارات قيادية أو تقنية أو عمل جماعي طبقتها.</p></li></ul>",
        },
      ],
    },
    volunteer: {
      ...sampleResume.sections.volunteer,
      name: "التطوع",
    },
    profiles: {
      ...sampleResume.sections.profiles,
      name: "الملفات الشخصية",
    },
    projects: {
      ...sampleResume.sections.projects,
      name: "المشاريع",
      items: [
        {
          ...sampleResume.sections.projects.items[0],
          name: "اسم المشروع",
          description: "دورك في المشروع",
          summary:
            "<p>اكتب وصفاً مختصراً للمشروع وإنجازاتك فيه.</p>",
        },
        {
          ...sampleResume.sections.projects.items[1],
          name: "اسم المشروع",
          description: "دورك في المشروع",
          summary:
            "<p>اكتب وصفاً مختصراً للمشروع وإنجازاتك فيه.</p>",
        },
      ],
    },
    publications: {
      ...sampleResume.sections.publications,
      name: "المنشورات",
    },
    references: {
      ...sampleResume.sections.references,
      name: "المراجع",
      items: [
        {
          ...sampleResume.sections.references.items[0],
          name: "متاحة عند الطلب",
        },
      ],
    },
    skills: {
      ...sampleResume.sections.skills,
      name: "المهارات",
      items: [
        {
          ...sampleResume.sections.skills.items[0],
          name: "فئة المهارة",
          description: "متقدم",
          keywords: ["المهارة 1", "المهارة 2", "المهارة 3", "المهارة 4"],
        },
        {
          ...sampleResume.sections.skills.items[1],
          name: "فئة المهارة",
          description: "متوسط",
          keywords: ["المهارة 1", "المهارة 2", "المهارة 3", "المهارة 4"],
        },
        {
          ...sampleResume.sections.skills.items[2],
          name: "فئة المهارة",
          description: "متوسط",
          keywords: ["المهارة 1", "المهارة 2", "المهارة 3", "المهارة 4"],
        },
      ],
    },
    hobbies: {
      ...sampleResume.sections.hobbies,
      name: "الهوايات",
      items: [
        { ...sampleResume.sections.hobbies.items[0], name: "كرة السلة" },
        { ...sampleResume.sections.hobbies.items[1], name: "القراءة" },
      ],
    },
    mostProudOf: {
      ...sampleResume.sections.mostProudOf,
      name: "نقاط القوة الأساسية",
      items: [
        { ...sampleResume.sections.mostProudOf.items[0], name: "مشاريع عالية التأثير", description: "قيادة وتسليم مشاريع رئيسية في الوقت المحدد، متجاوزاً التوقعات ومحققاً نتائج قابلة للقياس." },
        { ...sampleResume.sections.mostProudOf.items[1], name: "بناء فرق قوية", description: "تعزيز بيئات عمل تعاونية رفعت الإنتاجية والروح المعنوية والنمو المهني." },
        { ...sampleResume.sections.mostProudOf.items[2], name: "النمو المهني المستمر", description: "ملتزم بالتعلم المستمر من خلال الشهادات وورش العمل ومتابعة أحدث التطورات." },
      ],
    },
    myMind: {
      ...sampleResume.sections.myMind,
      name: "العقلية والقوة",
      items: [
        { ...sampleResume.sections.myMind.items[0], label: "القيادة", description: "توجيه الفرق نحو الأهداف المشتركة بثقة" },
        { ...sampleResume.sections.myMind.items[1], label: "حل المشكلات", description: "تحليل التحديات وتقديم نتائج فعالة" },
        { ...sampleResume.sections.myMind.items[2], label: "التعاون", description: "العمل بفعالية مع فرق متنوعة لتحقيق النجاح" },
        { ...sampleResume.sections.myMind.items[3], label: "الإبداع", description: "توليد أفكار مبتكرة وحلول فريدة" },
      ],
      ringThickness: 4,
      showLegend: true,
      legendPlacement: "right" as const,
    },
    interests: {
      ...sampleResume.sections.interests,
      name: "الاهتمامات",
      items: [
        { ...sampleResume.sections.interests.items[0], name: "الابتكار التقني", keywords: ["الذكاء الاصطناعي", "التعلم الآلي", "البلوك تشين"] },
        { ...sampleResume.sections.interests.items[1], name: "التطوير المهني", keywords: ["القيادة", "الإرشاد", "شبكات العمل"] },
      ],
    },
    languages: {
      ...sampleResume.sections.languages,
      name: "اللغات",
      items: [
        { ...sampleResume.sections.languages.items[0], name: "العربية", description: "اللغة الأم" },
        { ...sampleResume.sections.languages.items[1], name: "الإنجليزية", description: "بطلاقة" },
      ],
    },
    custom: {},
  },
  metadata: {
    ...sampleResume.metadata,
    locale: "ar-SA",
    typography: {
      ...sampleResume.metadata.typography,
      font: {
        ...sampleResume.metadata.typography.font,
        family: "El Messiri",
        subset: "latin",
        variants: ["regular"],
      },
    },
  },
};

// Mapping of locales to sample resumes
export const localizedSampleResumes: Record<string, ResumeData> = {
  "en-US": {
    ...sampleResumeEnglish,
    metadata: {
      ...sampleResumeEnglish.metadata,
      locale: "en-US",
    },
  },
  "es-ES": {
    ...sampleResumeSpanish,
    metadata: {
      ...sampleResumeSpanish.metadata,
      locale: "es-ES",
    },
  },
  "de-DE": {
    ...sampleResumeGerman,
    metadata: {
      ...sampleResumeGerman.metadata,
      locale: "de-DE",
    },
  },
  "fr-FR": {
    ...sampleResumeFrench,
    metadata: {
      ...sampleResumeFrench.metadata,
      locale: "fr-FR",
    },
  },
  "ar-SA": {
    ...sampleResumeArabic,
    metadata: {
      ...sampleResumeArabic.metadata,
      locale: "ar-SA",
    },
  },
  "pt-BR": {
    ...sampleResumeEnglish,
    metadata: {
      ...sampleResumeEnglish.metadata,
      locale: "pt-BR",
    },
  }, // Placeholder: would be replaced with Portuguese sample
  "tl-PH": {
    ...sampleResumeEnglish,
    metadata: {
      ...sampleResumeEnglish.metadata,
      locale: "tl-PH",
    },
  }, // Placeholder: would be replaced with Tagalog sample
  "hi-IN": {
    ...sampleResumeEnglish,
    metadata: {
      ...sampleResumeEnglish.metadata,
      locale: "hi-IN",
    },
  }, // Placeholder: would be replaced with Hindi sample
};

// Function to get the sample resume for a specific locale
export const getSampleResumeForLocale = (locale: string): ResumeData => {
  return localizedSampleResumes[locale] ?? sampleResumeEnglish;
};
